import React, { Children } from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { key } from '@philips-emr/tws-utils';

import { EventTokenList } from '../..';

function HourText({ children }) {
  if (!Children.count(children)) {
    return null;
  }

  return <div className="c-calendar-hour__text">{msg(children)}</div>;
}

HourText.propTypes = {
  children: PropTypes.string,
};

function transformEvent(event) {
  const hour = moment.utc(event.date).format('HH:mm');
  const title = `${hour} | ${event.title}`;

  return {
    ...event,
    date: moment.utc(event.date),
    title,
  };
}

function HourEvents({ events }) {
  if (!events || (events && !events.length)) {
    return null;
  }

  const eventTokens = events.filter((event) => event.date).map(transformEvent);

  if (!eventTokens.length) {
    return;
  }

  return <EventTokenList data={eventTokens} displayQuantity={2} />;
}

HourEvents.propTypes = {
  events: PropTypes.array,
};

function Hour({ text, events }) {
  return (
    <div className="c-calendar__hour">
      <HourText>{text}</HourText>
      <HourEvents events={events} />
    </div>
  );
}

Hour.propTypes = {
  text: PropTypes.string,
  events: PropTypes.array,
};

function WeeklyHourColumn({ hours }) {
  return (
    <div className="c-calendar__column">
      {hours.map((hour) => (
        <Hour
          key={key('c-calendar-weekly-hour')}
          text={hour.text}
          events={hour.events}
        />
      ))}
    </div>
  );
}

WeeklyHourColumn.propTypes = {
  hours: PropTypes.array,
};

export default WeeklyHourColumn;
